import React from 'react';
import PublicReportsPage from '../../../pages/PublicReportsPage';

const ReportsContent: React.FC = () => {
  return <PublicReportsPage />;
};

export default ReportsContent;
